import {
  UpdateAssetDtoProducedByEnum,
  UploadStateRulesDtoFinalizedStatesEnum,
  UploadWithAssetsDtoStateEnum,
  UploadWithAssetsDtoTypeEnum,
  UploadWithSlimAssetsDtoStateEnum,
} from "generated";

export type FieldAccessContext = {
  isAdmin: boolean;
  isIngkaUser: boolean;
  uploadState: UploadWithSlimAssetsDtoStateEnum;
  uploadType?: UploadWithAssetsDtoTypeEnum;
  producedBy?: UpdateAssetDtoProducedByEnum;
  isOnlySocialMedia?: boolean;
  confirmEndOfNegotiatedUsageRights?: boolean;
  hasEndOfNegotiatedUsageRightsDate?: boolean;
};

export const FINALIZED_UPLOAD_STATES: UploadWithAssetsDtoStateEnum[] =
  Object.values(UploadStateRulesDtoFinalizedStatesEnum);

export function isLockedForOwner(
  ctx: Pick<FieldAccessContext, "isAdmin" | "uploadState">,
): boolean {
  return !ctx.isAdmin && ctx.uploadState !== "DRAFT";
}

export function isUploadFinalized(
  ctx: Pick<FieldAccessContext, "uploadState">,
): boolean {
  return FINALIZED_UPLOAD_STATES.includes(ctx.uploadState);
}

export function isLockedForNonIngkaUser(
  ctx: Pick<FieldAccessContext, "isIngkaUser">,
): boolean {
  return !ctx.isIngkaUser;
}

export function isLockedForNonAdmin(
  ctx: Pick<FieldAccessContext, "isAdmin">,
): boolean {
  return !ctx.isAdmin;
}

export function isProducedByLocalOrAgency(
  ctx: Pick<FieldAccessContext, "producedBy">,
): boolean {
  return (
    ctx.producedBy === "INTERNAL_LOCAL_PRODUCTION" ||
    ctx.producedBy === "AGENCY"
  );
}

export function isSocialMediaOnly(
  ctx: Pick<FieldAccessContext, "isOnlySocialMedia">,
): boolean {
  return Boolean(ctx.isOnlySocialMedia);
}

export function isDocumentUpload(
  ctx: Pick<FieldAccessContext, "uploadType">,
): boolean {
  return ctx.uploadType === UploadWithAssetsDtoTypeEnum.Document;
}

export function isEndDateConfirmedUnspecified(
  ctx: Pick<FieldAccessContext, "confirmEndOfNegotiatedUsageRights">,
): boolean {
  return Boolean(ctx.confirmEndOfNegotiatedUsageRights);
}

export function hasEndDateValue(
  ctx: Pick<FieldAccessContext, "hasEndOfNegotiatedUsageRightsDate">,
): boolean {
  return Boolean(ctx.hasEndOfNegotiatedUsageRightsDate);
}
